import { RangeModel } from '../../../Common/Filter/models/range.model';
import { ProminenceGroupApiModel } from '../../monitoring/model/prominence-group-api.model';

export class ProminenceFilterApiModel {
    filters?: ProminenceRangeFilterApiModel[] = [];
}

export class ProminenceRangeFilterApiModel {
    prominenceGroup?: ProminenceGroupApiModel;
    ranges?: RangeModel[] = [];
}
